import React from 'react';
import EvidenceCard from './EvidenceCard';

/**
 * Language Proficiency 카드
 *
 * States:
 *   - levels = []  → text: "No language info added"
 *   - levels = ['TOPIK Level 4', 'English Intermediate']  → chips (active)
 *   - levels = ['TOPIK Level 5']  → chip (active)
 *
 * @param {string[]} levels - e.g. ['TOPIK Level 4', 'English Intermediate']
 */
function LanguageProficiencyCard({
  levels = [],
  onUpdate,
  onAddLevels,
  evidenceItems,
  sessionId,
  initialScore,
  onEvidenceSave,
  className,
}) {
  const chips = levels.length > 0
    ? levels.map((label) => ({ label }))
    : undefined;

  return (
    <EvidenceCard
      color='white'
      title='Language Proficiency'
      chips={chips}
      statusText='No language info added'
      secondaryLabel='Update'
      primaryLabel='Add levels'
      onSecondaryClick={onUpdate}
      onPrimaryClick={onAddLevels}
      evidenceItems={evidenceItems}
      sessionId={sessionId}
      initialScore={initialScore}
      onEvidenceSave={onEvidenceSave}
      className={className}
    />
  );
}

export default LanguageProficiencyCard;
